import HttpClientToken from '../../services/HttpClientToken';

import { defaultTipoConsecutivo, TipoConsecutivoProps } from '../../interfaces/catalogos/TipoConsecutivoInterface';

export const TipoConsecutivos = () => {

    return new Promise<TipoConsecutivoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoConsecutivo/', token)
            .then( ({ data } : { data : TipoConsecutivoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoConsecutivo = () => {

    return new Promise<TipoConsecutivoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoConsecutivo/ObtenerTipoConsecutivos', token)
            .then( ({ data } : { data : TipoConsecutivoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoConsecutivo = ( params: TipoConsecutivoProps ) => {

    return new Promise<TipoConsecutivoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoConsecutivo/Actualizar', params, token)
            .then( ({ data } : { data : TipoConsecutivoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultTipoConsecutivo });
            });

        }

    });

}

export const AgregarTipoConsecutivo = ( params: TipoConsecutivoProps ) => {

    return new Promise<TipoConsecutivoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoConsecutivo/Agregar', params, token)
            .then( ({ data } : { data : TipoConsecutivoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultTipoConsecutivo });
            });

        }

    });

}
